<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Activity Certificate Rule</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row justify="center" dense class="no-display">
  <v-col cols="12" sm="4" md="4" style="margin-top: 10px;">
    <v-autocomplete
      v-model="selected_academic_year_id"
      :items="academic_year_list"
      item-text="academic_year"
      item-value="academic_year_id"
      label="Select Academic Year"
      outlined
      dense
      rounded
      clearable
      required
    />
  </v-col>

  <v-col cols="12" sm="4" md="4" style="margin-top: 10px;">
    <v-autocomplete
  v-model="selected_activity_id"
  :items="activity_list_with_all"
  item-text="activity_name"
  item-value="activity_id"
  label="Select Activity"
  outlined
  dense
  rounded
  clearable
  required
/>
  </v-col>

  <v-col cols="12" sm="4" md="4" class="d-flex align-center" style="margin-top: -20px;">
    <v-btn
      class="button"
      :disabled="!selected_academic_year_id || !selected_activity_id"
      @click="fetchCertificateRules"
    >
      Fetch
    </v-btn>
  </v-col>
</v-row>
      <v-data-table :headers="headers" :items="activity_certificate_rule_list" class="elevation-1 mytable" dense :search="search">

        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <v-btn class="ma-2 no-display" rounded outlined small color="success"
                    @click="downloadFile" :loading="loader"><v-icon>mdi-export</v-icon>Export</v-btn>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small dense class="button" v-on="on">Add Certificate Rule</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                            <v-icon color="error">*</v-icon>
                         <v-autocomplete dense required v-model="addedItem.academic_year_id"
                          :items="academic_year_list" item-text="academic_year" item-value="academic_year_id" label="Select Academic Year" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>  
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete dense required v-model="editedItem.academic_year_id"
                          :items="academic_year_list" item-text="academic_year" item-value="academic_year_id" label="Select Academic Year" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>
                     <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                            <v-icon color="error">*</v-icon>
                         <v-autocomplete dense required v-model="addedItem.activity_id"
                          :items="activity_list" item-text="activity_name" item-value="activity_id" label="Select Activity" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>  
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-autocomplete dense required v-model="editedItem.activity_id"
                          :items="activity_list" item-text="activity_name" item-value="activity_id" label="Select Activity" outlined
                          persistent-hint>
                        </v-autocomplete>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined
                          v-model="addedItem.certificate_rule" label="Certificate Rule"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.certificate_rule" dense persistent-hint
                           label="Certificate Rule"></v-text-field>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined
                          v-model="addedItem.minimum_attendance_percentage" label="Minimum Attendance %"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.minimum_attendance_percentage" dense persistent-hint
                           label="Minimum Attendance %"></v-text-field>
                      </v-col>
                       <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-icon color="error">*</v-icon>
                    <v-text-field dense outlined
                          v-model="addedItem.minimum_attended_hours" label="Minimum Attended Hours"></v-text-field>
                      </v-col>
                         <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.minimum_attended_hours" dense persistent-hint
                           label="Minimum Attended Hours"></v-text-field>
                      </v-col>
                      <!-- ADD Form Checkboxes -->
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                      <v-checkbox dense v-model="addedItem.is_feedback_required" color="success" label="Is Feedback Required ?"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                      <v-checkbox dense v-model="addedItem.is_payment_required" color="success" label="Is Payment Required ?"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                      <v-checkbox
                        dense
                        v-model="addedItem.is_approval_required"
                        :true-value="true"
                        :false-value="false"
                        color="success"
                        label="Is Approval Required ?"
                      ></v-checkbox>
                    </v-col>

                    <!-- EDIT Form Checkboxes -->
                    <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                      <v-checkbox dense v-model="editedItem.is_feedback_required" color="success" label="Is Feedback Required ?"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                      <v-checkbox dense v-model="editedItem.is_payment_required" color="success" label="Is Payment Required ?"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                      <v-checkbox
                        dense
                        v-model="editedItem.is_approval_required"
                        :true-value="true"
                        :false-value="false"
                        color="success"
                        label="Is Approval Required ?"
                      ></v-checkbox>
                    </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions style="justify-content:  center;">
                  <!-- <v-spacer></v-spacer> -->
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.isactive="{ item }">
        <v-switch inset dense v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
        </template>
        <template v-slot:item.status="{ item }">
          <span v-if="item.isactive==true">
            <v-icon class="mr-2 pl-3 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 pl-3 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>
        <template v-slot:item.is_feedback_required="{ item }">
  <span v-if="item.is_feedback_required">
    <v-icon class="mr-2 pl-3 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
  </span>
  <span v-else>
    <v-icon class="mr-2 pl-3 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
  </span>
</template>

<template v-slot:item.is_payment_required="{ item }">
  <span v-if="item.is_payment_required">
    <v-icon class="mr-2 pl-3 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
  </span>
  <span v-else>
    <v-icon class="mr-2 pl-3 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
  </span>
</template>
<template v-slot:item.is_approval_required="{ item }">
  <v-icon
    :color="item.is_approval_required === true ||
            item.is_approval_required === 'true' ||
            item.is_approval_required === 1 ? 'success' : 'error'"
  >
    {{ item.is_approval_required === true ||
       item.is_approval_required === 'true' ||
       item.is_approval_required === 1
       ? 'mdi-check-circle-outline'
       : 'mdi-close-circle-outline' }}
  </v-icon>
</template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
             <v-avatar style="" size="25" class="edit-avatar ml-2">
                <v-icon class="v-icon-size mr-2 ml-2"  @click="deleteItem(item)">delete</v-icon>
             </v-avatar>
             <!-- <v-switch v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'" @change="toggle(item)"></v-switch> -->  
          </div>
          </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import * as XLSX from "xlsx";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    overlay: false,
    errorMsg: {
      certificate_rule: false,
      minimum_attendance_percentage:false,
      minimum_attended_hours:false,
      is_feedback_required:false,
      is_payment_required:false,
      is_approval_required:false,
    },
    selected_academic_year_id: null,
    selected_activity_id: null,
    hasFetched: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
    
      {
        text: "Activity",
        align: "left",
        sortable: false,
        value: "activity_name",
      },
      {
        text: "Certificate Rule",
        align: "left",
        sortable: false,
        value: "certificate_rule",
      },
      {
        text: "Minimum Attendance %",
        align: "left",
        sortable: false,
        value: "minimum_attendance_percentage",
      },
      {
        text: "Minimum Attended Hours",
        align: "left",
        sortable: false,
        value: "minimum_attended_hours",
      },
      {
        text: "Is Feedback Required",
        align: "left",
        sortable: false,
        value: "is_feedback_required",
      },
      {
        text: "Is Payment Required",
        align: "left",
        sortable: false,
        value: "is_payment_required",
      },
       {
        text: "Is Approval Required",
        align: "left",
        sortable: false,
        value: "is_approval_required",
      },
      {
        text: "Active",
        align: "center",
        sortable: true,
        value: "isactive",
      },
       {
        text: "Status",
        align: "center",
        sortable: true,
        value: "status",
      },
      { text: "Actions", value: "action", sortable: false,align: "center"},
    ],
    activity_certificate_rule_list: [],
    academic_year_list: [],
    activity_list: [],
    editedIndex: -1,
    addedItem: {
      certificate_rule: "",
      minimum_attendance_percentage:"",
      minimum_attended_hours:"",
      is_feedback_required:false,
      is_payment_required:false,
      is_approval_required:false,

    },
    editedItem: {
      id: "",
      certificate_rule: "",
      minimum_attendance_percentage:"",
      minimum_attended_hours:"",
      is_feedback_required:false,
      is_payment_required:false,
      is_approval_required:false,
      isactive: true,
    },
    defaultItem: {
      id: "",
      certificate_rule: "",
      minimum_attendance_percentage:"",
      minimum_attended_hours:"",
      is_feedback_required:false,
      is_payment_required:false,
      is_approval_required:false,
      affiliation_type_id:"",
      isactive: true,
    },
    mobileRules: [
    v => !!v || 'Mobile number is required',
    v => /^[6-9][0-9]{9}$/.test(v) || 'Enter a valid 10 digit mobile number'
],
  }),

  computed: {
  formTitle() {
  return this.editedIndex === -1
    ? "New Activity Certificate Rule"
    : "Edit Activity Certificate Rule";
},
   activity_list_with_all() {
    return [
      {
        activity_id: "ALL",
        activity_name: "All Activities"
      },
      ...this.activity_list
    ];
  },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.feesComponent = false;
    },
   onLoad(fetchRules = false) {
  this.overlay = true;

  const requestData = fetchRules
    ? {
        academic_year_id: this.selected_academic_year_id,
        activity_id: this.selected_activity_id
      }
    : {};

  axios
    .post("/Activity/getActivityCertificateRule", requestData)
    .then((res) => {
      if (res.data.msg == "200") {
        this.academic_year_list = res.data.academic_year_list || [];
        this.activity_list = res.data.activity_list || [];

        if (fetchRules) {
          let fetchedList = res.data.activity_certificate_rule_list || [];
          if (this.selected_activity_id && this.selected_activity_id !== "ALL") {
            fetchedList = fetchedList.filter(
              (item) => item.activity_id === this.selected_activity_id
            );
          }

          this.activity_certificate_rule_list = fetchedList;
          this.hasFetched = true;
        }
      }
    })
    .catch((error) => {
      console.log(error);
      this.showSnackbar("#b71c1c", "Something went wrong...");
    })
    .finally(() => {
      this.overlay = false;
    });
},
fetchCertificateRules() {
  if (!this.selected_academic_year_id || !this.selected_activity_id) {
    this.showSnackbar(
      "#b71c1c",
      "Please select Academic Year and Activity."
    );
    return;
  }

  this.activity_certificate_rule_list = [];
  this.hasFetched = false;

  this.onLoad(true);
},
     downloadFile() {
    this.loader = true;

    const excelData = this.activity_certificate_rule_list.map((item, index) => ({
      "S.No": index + 1,
      "Rule": item.certificate_rule,
       "Minimum Attendance Percentage": item.minimum_attendance_percentage,
       "Minimum Attended Hours": item.minimum_attended_hours,
        "Feedback Required": item.is_feedback_required,
        "Payment Required": item.is_payment_required,
        "Approval Required": item.is_approval_required,
      "Status": item.isactive ? "Active" : "Inactive"
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Resource Person");
    XLSX.writeFile(workbook, "resource_person.xlsx");

    this.loader = false;
  },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.activity_certificate_rule_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

     deleteItem(item) {
      if (confirm("Are you sure you want to delete this Activity Certificate Rule?")) {
      const data = {
        id: item.id
      };
      axios
        .post("/Activity/deleteActivityCertificateRule", data)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Activity Certificate Rule Deleted Successfully...");
            this.fetchCertificateRules();
          }
           else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      }
      this.close();
    },


    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Activity/editActivityCertificateRule", this.editedItem)
            .then((res) => {
              console.log("Edit response:", res.data);

              if (res.data.status && res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.activity_certificate_rule_list[this.editedIndex],
                  this.editedItem
                );

                this.showSnackbar(
                  "#4caf50",
                  "Activity Certificate Rule Updated successfully..."
                );

                this.close();
               this.fetchCertificateRules();
              } else if (res.data.status && res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Activity Certificate Rule not found!!!"
                );
                this.close(); // ADDED THIS

              } else {
                this.showSnackbar(
                  "#b71c1c",
                  "Unable to update Activity Certificate Rule."
                );
                this.close(); // ADDED THIS
              }
            })
            .catch((error) => {
              console.log("Edit error:", error);
              this.showSnackbar(
                "#b71c1c",
                "Something went wrong while updating Activity Certificate Rule."
              );
              this.close(); // ADDED THIS
            })
            .finally(() => {
              this.addedItem.certificate_rule = "";
              this.addedItem.minimum_attendance_percentage = "";
              this.addedItem.minimum_attended_hours = "";
              this.addedItem.is_feedback_required = false;
              this.addedItem.is_payment_required = false;
              this.addedItem.is_approval_required = false;
            });
        }
      } else {
        if (
          this.addedItem.certificate_rule == "" ||
          this.addedItem.certificate_rule == null
        ) {
          this.showSnackbar(
            "#b71c1c",
            "Please enter Activity Certificate Rule..."
          );
          return;
        }
        axios
          .post("/Activity/saveActivityCertificateRule", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.showSnackbar(
                "#4caf50",
                "Activity Certificate Rule added successfully..."
              );
             this.fetchCertificateRules();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "Activity Certificate Rule already present!!!"
              );
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.addedItem.certificate_rule = "";
            this.addedItem.minimum_attendance_percentage = "";
            this.addedItem.minimum_attended_hours = "";
            this.addedItem.is_feedback_required = false;
            this.addedItem.is_payment_required = false;
            this.addedItem.is_approval_required = false;
          });

        this.close();
      }
    },

     toggle(item) {
      const data = {
        id: item.id,
        isactive: item.isactive
      };
      axios
        .post("/Activity/toggleActivityCertificateRule", data)
        .then((res) => {
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Activity Certificate Rule Updated Successfully...");
            this.fetchCertificateRules();
          }
           else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      this.close();
    },

    isValidated() {
      if (this.editedItem.certificate_rule != "") {
        return true;
      } else {
        if (!this.editedItem.certificate_rule) {
           this.showSnackbar("#b71c1c", "Please enter Activity Certificate Rule...");
          this.errorMsg.certificate_rule = true;
        }

        return false;
      }
    },
    
       
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.active-switch-container {
  display: flex;
  align-items: center;
  height: 100%;
}

.active-switch-container .v-switch {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.mytable ::v-deep tbody tr{
   min-height:50px;
}

.mytable ::v-deep tbody td {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
</style>
